import SVG from './SVG.styled';
import { IPropsSVGType } from 'src/types/svg.types';

export default function Youtube({color="main-orange", hover="orange-2"}: IPropsSVGType) {
  return (
    <SVG
      $hover={hover}
      $color={color}
      $isHover={true}
      width="27"
      height="24"
      viewBox="0 -4 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
        <path xmlns="http://www.w3.org/2000/svg" d="M19.8078 0H5.19218C2.32462 0 0 2.10246 0 4.69598V11.304C0 13.8975 2.32462 16 5.19218 16H19.8078C22.6754 16 25 13.8975 25 11.304V4.69598C25 2.10246 22.6754 0 19.8078 0ZM16.2964 8.3215L9.46017 11.2704C9.27802 11.3489 9.06761 11.2288 9.06761 11.0463V4.96427C9.06761 4.77916 9.28355 4.6592 9.46608 4.74287L16.3023 7.87606C16.5055 7.9692 16.502 8.23283 16.2964 8.3215Z" fill="#F61C0D"/>
    </SVG>
  );
}
